import { render, staticRenderFns } from "./noticeBell.vue?vue&type=template&id=4feaf835&scoped=true&"
import script from "./noticeBell.vue?vue&type=script&lang=js&"
export * from "./noticeBell.vue?vue&type=script&lang=js&"
import style0 from "./noticeBell.vue?vue&type=style&index=0&id=4feaf835&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feaf835",
  null
  
)

export default component.exports